/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterLayersQueryDto
 */
export interface FilterLayersQueryDto {
    /**
     * 
     * @type {boolean}
     * @memberof FilterLayersQueryDto
     */
    includeSubmissionSettings?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilterLayersQueryDto
     */
    submissionId: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilterLayersQueryDto
     */
    includeRateAdequacy?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilterLayersQueryDto
     */
    currency?: string;
}

/**
 * Check if a given object implements the FilterLayersQueryDto interface.
 */
export function instanceOfFilterLayersQueryDto(value: object): value is FilterLayersQueryDto {
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function FilterLayersQueryDtoFromJSON(json: any): FilterLayersQueryDto {
    return FilterLayersQueryDtoFromJSONTyped(json, false);
}

export function FilterLayersQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterLayersQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'includeSubmissionSettings': json['includeSubmissionSettings'] == null ? undefined : json['includeSubmissionSettings'],
        'submissionId': json['submissionId'],
        'includeRateAdequacy': json['includeRateAdequacy'] == null ? undefined : json['includeRateAdequacy'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function FilterLayersQueryDtoToJSON(json: any): FilterLayersQueryDto {
    return FilterLayersQueryDtoToJSONTyped(json, false);
}

export function FilterLayersQueryDtoToJSONTyped(value?: FilterLayersQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'includeSubmissionSettings': value['includeSubmissionSettings'],
        'submissionId': value['submissionId'],
        'includeRateAdequacy': value['includeRateAdequacy'],
        'currency': value['currency'],
    };
}

